import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import * as actions from '../../redux/actions/actions-learningmodule';
import Button from '../../components/Button';
import SearchBar from '../../components/SearchBar';
import BreadCrumb from '../../components/Breadcrumb';
import Loader from '../../components/Loader';

class LearningModule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchVal: ''
    };
    props.getLMlist(props.match.params.id);
  }


  deleteLM = (id, courseId) => {
    confirmAlert({
      title: 'Delete LearningModule',
      message: 'Are you sure to delete the LearningModule?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.props.deleteLM(id, courseId)
              .then(() => {
                toast.success('Deleted Successfully');
              }).catch((error) => {
                toast.error(error.message);
              });
          }
        },
        {
          label: 'No'
        }
      ]
    });
  }

  handleTableFilter = (search) => {
    this.setState({ searchVal: search });
  }

  setTableOption = () => (this.props.lmList && this.props.tableLoading ? <Loader /> : 'No Data Found');

  render() {
    const searchVal = this.state.searchVal.toLowerCase();
    const learningmodule = this.props.lmList.filter((item) => item.Name.toLowerCase().includes(searchVal));

    const columns = [{
      dataField: 'Name',
      text: 'Name'
    }, {
      dataField: 'Description',
      text: 'Description'
    }, {
      dataField: 'CreatedDateTime',
      text: 'Created at',
      formatter: (cell, row) => (
        new Date(cell).toLocaleDateString()
      ),
      sort: true
    }, {
      dataField: 'Id',
      text: 'Actions',
      headerStyle: {
        width: '160px'
      },
      formatter: (cell, row) => (
        <>
          <span
            role="presentation"
            className="fa fa-pencil-alt tableEdit"
            onClick={() => this.props.history.push({
              pathname: `/courses/learning-module-editor/${cell}`,
              state: { courseId: this.props.match.params.id }
            })}
          />
          <span
            role="presentation"
            className="fa fa-trash tableDelete"
            onClick={() => this.deleteLM(cell, this.props.match.params.id)}
          />
          <span
            role="presentation"
            className="fa fa-search-plus tableLM"
            onClick={() => this.props.history.push({
              pathname: `/courses/learning-object/${cell}`,
              state: { courseId: this.props.match.params.id }
            })}
          />
        </>
      )
    }];

    const defaultSorted = [{
      dataField: 'CreatedDateTime',
      order: 'desc'
    }];

    return (
      <div>
        <div className="container">
          <BreadCrumb currentPage="Learning Module" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-8">
                    {/* <span className="fa fa-cogs cardTitle"> Learning Module</span> */}
                    <SearchBar
                      placeholder="Search by Name"
                      handleChange={(e) => this.handleTableFilter(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 text-right">
                    <Button
                      className="btn btn-sm btn-secondary ml-1 float-right"
                      onClick={() => this.props.history.push({
                        pathname: '/courses/learning-module-editor/0',
                        state: { courseId: this.props.match.params.id }
                      })}
                    >
                      <span className="fas fa-plus" />
                      {' '}
                      Add New
                    </Button>
                    <Button
                      className="btn btn-sm btn-secondary ml-1 float-right"
                      onClick={() => this.props.history.goBack()}
                    >
                      <span className="fas fa-arrow-left" />
                      {' '}
                      Back
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">

                <BootstrapTable
                  keyField="Id"
                  data={learningmodule}
                  columns={columns}
                  pagination={paginationFactory()}
                  defaultSorted={defaultSorted}
                  noDataIndication={() => this.setTableOption()}
                  hover
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LearningModule.defaultProps = {
  tableLoading: false,
  lmList: null,
  getLMlist: null,
  deleteLM: null
};

LearningModule.propTypes = {
  tableLoading: PropTypes.bool,
  lmList: PropTypes.array,
  getLMlist: PropTypes.func,
  deleteLM: PropTypes.func
};

const mapStateToProps = ({ learningModule }) => ({
  tableLoading: learningModule.tableLoading,
  lmList: learningModule.lmList
});

const mapDispatchToProps = (dispatch) => ({

  getLMlist: (CourseId) => dispatch(actions.fetchLM(CourseId)),
  deleteLM: (id, CourseId) => dispatch(actions.deleteLM(id, CourseId))

});

export default connect(mapStateToProps, mapDispatchToProps)(LearningModule);
